import React from 'react';
import { Stack } from '@mui/material';
import { ComposableDeviceFormProps } from '../../../../components/ComposableDevice/ComposableDeviceForm/ComposableDeviceForm';
import * as yup from 'yup';
import { DecksForm } from './ComposableDeviceForm/DecksForm';
import { ImageForm } from './ComposableDeviceForm/ImageForm';
import { DeviceForm } from './ComposableDeviceForm/DeviceForm';

export const ComposableDeviceFormFROven = (
  props: ComposableDeviceFormProps
) => {
  const { formik } = props;

  return (
    <>
      <Stack display="grid" gridTemplateColumns={'1fr'} gap={1} marginTop={2}>
        <DeviceForm formik={formik} displayType={false} />
        <DecksForm
          formik={formik}
          setValidationSchema={props.setValidationSchema}
          validationSchema={props.validationSchema}
        />
        <ImageForm
          formik={formik}
          setImage={props.setImage}
          setLogo={props.setLogo}
          image={props.image}
          logo={props.logo}
          displayButtons={false}
        />
      </Stack>
    </>
  );
};
